<template>
  <div :class="['body', `body-${$mq}`]">
    <div :class="['topTitle', `topTitle-${$mq}`]">
      <div class="button" @click="$router.back()" v-if="$mq == 'desktop'">
        <img src="@/assets/next.svg" alt="" />
      </div>
      <div>{{ bottleName }}</div>
    </div>

    <div class="loading" v-if="loading">
      <div class="loading-spinner">
        <Spinner />
      </div>
    </div>

    <div class="question" v-else>
      <div class="introduction"></div>
      <div :class="['oeil', `oeil-${$mq}`]" v-if="testExists(eyeContainer)">
        <QuestionTasting
          :title="eye"
          :display="displayOeil"
          :questions="eyeContainer"
          :containe="this.question"
          @choice="choicesResponse"
          @click="displayOeil = !displayOeil"
        />
      </div>
      <div :class="['nez', `nez-${$mq}`]" v-if="testExists(noseContainer)">
        <QuestionTasting
          :title="nose"
          :display="displayNez"
          :questions="noseContainer"
          :containe="this.question"
          @choice="choicesResponse"
          @click="displayNez = !displayNez"
        />
      </div>
      <div :class="['degustation', `degustation-${$mq}`]" v-if="testExists(mouthContainer)">
        <QuestionTasting
          :title="mouth"
          :display="displayDegustation"
          :questions="mouthContainer"
          :containe="this.question"
          @choice="choicesResponse"
          @click="displayDegustation = !displayDegustation"
        />
      </div>
      <div :class="['bouche', `bouche-${$mq}`]" v-if="testExists(moreContainer)">
        <QuestionTasting
          :title="more"
          :display="displayBouche"
          :questions="moreContainer"
          :containe="this.question"
          @click="displayBouche = !displayBouche"
        />
      </div>
      <div :class="['opinion', `opinion-${$mq}`]" v-if="opinion">
        <TastingOpinion
          :response="opinionResponse"
          :display="displayOpinion"
          @click="displayOpinion = !displayOpinion"
        />
      </div>

      <div class="buttonValidate" @click="validate">
        {{ $t('forms.validate') }}
      </div>
    </div>
  </div>
</template>

<script>
import QuestionTasting from '@/components/tasting/QuestionTasting'
import TastingOpinion from '@/components/tasting/TastingOpinion'
import Spinner from '@/components/layout/Spinner'
import { functions } from '@/services/firebase'
import { mapGetters } from 'vuex'
import { SUBMIT_TASTING_ANSWER } from '@/store/modules/tasting/types'
import { REGISTER_COMPLETION } from '@/store/modules/completion/types'

export default {
  name: 'TastingListQuestion',
  components: { QuestionTasting, TastingOpinion, Spinner },
  data: () => ({
    bottleName: '',
    eye: '',
    nose: '',
    mouth: '',
    more: '',
    introductionText: '',
    eyeContainer: [],
    noseContainer: [],
    mouthContainer: [],
    moreContainer: [],
    opinionResponse: {},
    choices: [],
    displayOeil: false,
    displayNez: false,
    displayBouche: false,
    displayDegustation: false,
    displayOpinion: false,
    loading: false,
    opinion: true
  }),

  async mounted() {
    this.loading = true
    this.eye = this.$t('tasting.eye')
    this.nose = this.$t('tasting.nose')
    this.mouth = this.$t('tasting.mouth')
    this.more = this.$t('tasting.more')

    const callable = functions.httpsCallable('getEntry')
    const res = await callable({
      entryId: this.tastingId,
      locale: JSON.parse(localStorage.getItem('vuex_storage_key')).user.userInformations.language
    })
    const bodyRes = res.data.fields
    this.bottleName = bodyRes.bottleName
    this.loading = false

    /**
     * EyeScreens = Eye
     * noseScreens = Nose
     * aromaScreens = Mouth
     * MouthScreens = More
     */

    this.eyeContainer = bodyRes.eyeScreens
    this.noseContainer = bodyRes.noseScreens
    this.mouthContainer = bodyRes.aromaScreens
    this.moreContainer = bodyRes.mouthScreens
    let noseAnswerArray = []
    let mouthAnswerArray = []
    const eyeAnswer = this.eyeContainer.filter(item => item.fields.hasOwnProperty('answers'))[0]
      .fields.answers

    if (this.noseContainer != null) {
      const noseAnswer = this.noseContainer[0].fields.answers
      noseAnswerArray = noseAnswer.expectedResponse.choices.map(
        choice => noseAnswer.data.choices[choice].label
      )
    }
    if (this.mouthContainer != null) {
      for (let i = 0; i < this.mouthContainer.length; i++) {
        if (this.mouthContainer[i].fields.answers) {
          for (
            let j = 0;
            j < this.mouthContainer[i].fields.answers.expectedResponse.choices.length;
            j++
          ) {
            mouthAnswerArray.push(
              this.mouthContainer[i].fields.answers.expectedResponse.choices[j].value
            )
          }
        }
      }
    }
    this.opinionResponse = {
      eye: eyeAnswer.data.choices[eyeAnswer.expectedResponse.choice],
      nose: noseAnswerArray,
      mouth: mouthAnswerArray
    }
    if (Object.keys(this.opinionResponse).length === 0) {
      this.opinion = false
    }
  },

  computed: {
    ...mapGetters({
      question: 'currentState'
    }),
    tastingId() {
      return this.$route.params.tastingId
    }
  },
  methods: {
    testExists(container) {
      if (container != null) {
        if (container.length !== 0) {
          return true
        }
      }
      return false
    },

    choicesResponse(payload) {
      for (let i = 0; i < this.choices.length; i++) {
        // console.log('for', this.choices[i], payload.id)
        if (this.choices[i].id == payload.id) {
          this.choices[i].value = payload.value
          this.choices[i].correct = payload.correct
          return
        }
      }
      this.choices.push(payload)
    },
    selectImg(display) {
      return display ? 'img-active' : 'img'
    },
    // getIdArray(array) {
    //   let id = []

    //   for (let i = 0; i < array.length; i++) {
    //     id[i] = array[i].sys.id
    //   }

    //   return id
    // },
    // getQuestionArray(question, id) {
    //   let questions = []

    //   for (let i = 0; i < id.length; i++) {
    //     questions[i] = question.question.byId[id[i]]
    //     if (questions[i] == undefined) {
    //       questions[i] = question.transition.byId[id[i]]
    //     }
    //   }

    //   return questions
    // },
    validate() {
      for (let i = 0; i < this.choices.length; i++) {
        const answer = this.$route.params.tastingId + '.undefined.' + this.choices[i].id
        this.$store.dispatch(SUBMIT_TASTING_ANSWER, {
          questionId: this.choices[i].id,
          value: this.choices[i].value,
          answerId: answer,
          correct: this.choices[i].correct || false
        })

        this.$store.dispatch(REGISTER_COMPLETION, {
          contentType: 'tasting-question',
          id: this.choices[i].id,
          status: { complete: true, answerId: answer, correct: this.choices[i].correct || false }
        })
      }
      this.$router.push({
        name: 'tasting-rating',
        params: { tastingId: this.$route.params.tastingId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.loading {
  margin-top: -150px;
}

.buttonValidate {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background-color: $primary;
  border-radius: 18px;
  margin: 20px;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 13px;
  align-items: center;
  background-color: $primary;
  padding: 10px;
  .img {
    height: 30px;
    width: 30px;
  }
  .img-active {
    height: 30px;
    width: 30px;
    transform: rotate(90deg);
  }
}
.oeil {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 10px 0;
}
.oeil-mobile,
.oeil-table {
  width: 80%;
}
.degustation {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 10px 0;
}
.degustation-mobile,
.degustation-table {
  width: 80%;
}
.nez {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 10px 0;
}
.nez-mobile,
.nez-table {
  width: 80%;
}
.bouche {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 10px 0;
}
.bouche-mobile,
.bouche-table {
  width: 80%;
}
.opinion {
  display: flex;
  flex-direction: column;
  width: 60%;
  margin: 10px 0;
}
.opinion-mobile,
.opinion-table {
  width: 80%;
}
.question {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.body {
  display: flex;
  flex-direction: column;
  margin-top: 100px;
}
.body-mobile,
.body-tablet {
  padding-bottom: 90px;
}
.topTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  margin: 30px 100px;
}
.topTitle-mobile,
.topTitle-tablet {
  justify-content: center;
}
.button {
  margin-right: 35px;
  cursor: pointer;
  background-color: #ffffff;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow: 3px 3px 3px #bebebe, -4px -4px 4px #ffffff;
  img {
    height: 60%;
    width: 60%;
    margin-right: 4px;
    transform: rotate(180deg);
  }
  &:hover {
    box-shadow: -3px -3px 4px #bebebe, 3px 3px 2px #ffffff;
  }
}
</style>
